
import CustomerService from '@/services/CustomerService';

export default {
  props: {
    redirectToLink: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      customerService: new CustomerService({
        http: this.$http,
        auth: this.$auth,
        store: this.$store,
      }),
      account: {
        firstName: '',
        lastName: '',
        email: '',
        personalID: '',
      },
    };
  },
  methods: {
    decodeJwtResponse(token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    },

    handleCredentialResponse(response) {
      const user = this.decodeJwtResponse(response.credential);

      let name = user.name.split(' ');
      this.account.personalID = user.sub;
      this.account.email = user.email;
      this.account.firstName = name[0];
      this.account.lastName = name.length > 1 ? name[1] : name[0];

      this.login();
    },

    async login() {
      try {
        await this.customerService.loginWithGoogle({
          googleCustomerId: this.account.personalID,
          email: this.account.email,
          firstName: this.account.firstName,
          lastName: this.account.lastName,
          languageIsoCode: this.$i18n.locale,
          currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        });

        this.$store.commit('shared/menu/toggle', { tabActive: 1, open: false });

        // this.$gtag.event('login', { method: 'Google' });

        this.$notify({
          title: this.$t('welcome_connected.title'),
          message: this.$t('welcome_connected.message'),
          type: 'success',
        });

        this.redirectAfterLogin();
      } catch (err) {
        console.error('Google login failed', err);
      }
    },

    redirectAfterLogin() {
      let redirectTo = this.redirectToLink || '/account/informations';
      if (this.$route.query.redirect) {
        if (this.$route.query.redirect === 'loyalty-program') {
          redirectTo = '/account/loyalty/membership';
        } else {
          redirectTo = '/cart/delivery';
        }
      }

      this.$router.push({
        path: this.localePath(redirectTo),
      });
    },

    initGoogleButton() {
      if (!window.google || !window.google.accounts) return;

      google.accounts.id.initialize({
        client_id: process.env.GOOGLE_CLIENT_ID,
        callback: this.handleCredentialResponse,
      });

      google.accounts.id.renderButton(this.$refs.gAuthBtn, {
        type: 'icon',       // Only the "G" icon
        theme: 'outline',    // White background with outline
        size: 'large',       // Large size
        shape: 'circle',     // Makes the button circular
      });
    },
  },
  mounted() {
    if (window.google && window.google.accounts) {
      this.initGoogleButton();
    } else {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => this.initGoogleButton();
      document.head.appendChild(script);
    }
  },
};
